import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavItemLink } from '../components/item/NavItem';

export const NavCodes: FC = () => (
  <NavItemLink href="/l/texts/codes" source="header">
    <FormattedMessage id="navigation/NavCodes.tsx/1" />
  </NavItemLink>
);
